import React from 'react'
import { BoundActionCreator } from '@sendoutcards/core'
import UserAvatar from 'react-user-avatar'
import Button from '@material-ui/core/Button'
// @src imports
import { Icon } from 'src/chrome'
import { connect } from 'src/redux/connect'
import { openCatalog } from 'src/redux/actions/routeAliases'
import { FlexColumn, FlexRow } from 'src/styled'
import { AccountFragment } from 'src/graphql'
import { clearStorefront } from 'src/redux/actions/storefront'

import styles from './sponsorBar.module.scss'

interface SponsorBarProps {
  account: {
    user: Partial<AccountFragment>
  }

  clearStorefront: BoundActionCreator<typeof clearStorefront>
}

const SponsorBar: React.FC<SponsorBarProps> = props => {
  const [myStory, toggleStory] = React.useState(false)

  const { clearStorefront } = props
  const { firstName, lastName, storefront } = props.account.user
  const fullName = `${firstName} ${lastName}`
  return (
    <FlexRow className={styles.sponsorBar}>
      <FlexColumn
        style={{
          color: '#333',
          width: '100%',
          textAlign: 'right',
        }}
      >
        <div style={{ marginRight: '20px', marginTop: '20px', zIndex: 10000 }}>
          <span onClick={clearStorefront}>
            <Icon icon={'CLOSE'} color={'#6f8394'} size={18} />
          </span>
        </div>
      </FlexColumn>
      <div className={styles.sponsor}>
        <FlexRow className={styles.user}>
          <UserAvatar
            name={fullName}
            src={storefront && storefront.mugshot && storefront.mugshot.url}
            size={150}
            style={{
              fontSize: '3.7rem',
              color: '#fff',
              letterSpacing: 1,
            }}
          />
        </FlexRow>
        <FlexColumn className={styles.sponsorInfo}>
          <h3>
            {fullName}
            <p>Affiliate</p>
          </h3>
          {myStory && <p>{storefront && storefront.biography}</p>}
          <div className={styles.actions}>
            <Button variant="outlined" onClick={() => toggleStory(!myStory)}>
              {myStory ? 'Show Less' : 'About Me'}
            </Button>
          </div>
        </FlexColumn>
      </div>
    </FlexRow>
  )
}

export default connect(undefined, {
  clearStorefront,
  openCatalog,
})(SponsorBar)
